import axios from 'axios';
import authHeader from "@/service/auth-header";

class ClientProvisionComponentService {

    async getClientProvisionComponents(id) {
        return await axios.get(`/api/clientprovisioncomponent/${id}`, {headers: authHeader()})
    }

    async getClientProvisionComponentsForClient(id) {
        return await axios.get(`/api/clientprovisioncomponent/client/${id}`, {headers: authHeader()})
    }

    // async createProvisionForClient(clientId, provisionId) {
    //     return await axios.post(`/api/clientprovision/${clientId}/${provisionId}`, null, {headers: authHeader()});
    // }
    //
    // async updateSpecificProvisionForClient(id, data) {
    //     return await axios.put(`/api/clientprovision/${id}`, data, {headers: authHeader()});
    // }
    //
    // async deleteSpecificProvisionForClient(id) {
    //     return await axios.delete(`/api/clientprovision/${id}`, {headers: authHeader()})
    // }

}

export default new ClientProvisionComponentService();
